// When setting a default route component sometimes you will land on it without
// the path matching the one desired for that page. Use this hook to redirect to
// the desired route. It should only be used inside of whichever component is intended
// to be the default fallback.

import { useLocation, useNavigate } from '@reach/router';

// to be the default component in reach-router.
export const useDefaultRoute = (path: string) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  if (pathname !== path) {
    navigate(path);
  }
};
